export const appContextMock = {
  currentUser: {
    id: 1
  },
  apiToken: {
    getRawToken: () => {},
    getIssuingTestline: () => {}
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/app-context/app-context.mock.ts